// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__pyYNI","title":"AfterBackImages_title__mb6q3","images":"AfterBackImages_images__3I5jA"};